<script>
import stepsMixin from '@/mixins/stepsMixin'
import { mapGetters, mapMutations } from 'vuex'
export default {
	mixins: [stepsMixin],
	data() {
		return {
			
		}
	},
	computed: {
		...mapGetters({
			showHelp: 'arceStatus/showHelp'
		})
	},
	methods: {
		checkHelpers() {
			let help = this.$route.params.help == 'true' ||  this.$route.params.help == 'help'
			if(help) {
				this._setHelp(help)
			}
		},
		...mapMutations({
			_setHelp: 'arceStatus/setHelp'
		})
	},
	mounted() {
		this.checkHelpers()
		this.hiddenSteps()
		this.showSteps('myTour')
	}
}
</script>
<template>
	<div class="d-flex flex-wrap px-1 py-1">
		<div class="col-12 col-lg-8 col-xl-9 p-0">
			<div class="d-flex flex-wrap py-1">
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						<div class="s-panel__body">
							<a href="#">Biblioteca</a>
							<span class="px-1">/</span>
							<a href="#">Wiki Red BeyG</a>
							<span class="px-1">/</span>
							<a href="#">Tecnosoluciones móvil</a>
							<span class="px-1">/</span>
							<a href="#">RAR</a>
						</div>
					</div>
				</div>
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						<div class="s-panel__header">
							<h3 class="title">Elementos para aprobar</h3>
						</div>
						<div class="s-panel__body">
							<p class="text-center mb-5">No hay solicitudes de aporbación que requieran su atención en este momento</p>
						</div>
					</div>
				</div>
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						<div class="s-panel__header">
							<h3 class="title">% Logro por Indicador</h3>
						</div>
						<div class="s-panel__body">
							<div class="s-chart">
								<p class="text-center mb-5">No podemos crear esta gráfica por que no hay datos</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 col-lg-4 col-xl-3 p-0">
			<div class="d-flex flex-wrap">
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						<div class="s-panel__header">
							<h3 class="title">Tareas de hoy</h3>
						</div>
						<div class="s-panel__body">
							<div class="text-center">
								<img class="s-panel__svg" src="@/assets/simulator/noTasks.svg" alt="">
								<p class="m-0 px-5">No hay nada pendiente para hoy. Tome la iniciativa y vuelva pronto.</p>
							</div>
						</div>
						<div class="s-panel__footer">
							<div class="text-center">
								<a href="#">Ver todos</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						<div class="s-panel__header">
							<h3 class="title">Eventos del día</h3>
						</div>
						<div class="s-panel__body">
							<div class="text-center">
								<img class="s-panel__svg" src="@/assets/simulator/noEvents.svg" alt="">
								<p class="m-0 px-5">Parece que no tiene nada pendiente para el resto del día.</p>
							</div>
						</div>
						<div class="s-panel__footer">
							<div class="text-center">
								<a href="#">Ver todos</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 px-2 py-2">
					<div class="s-panel">
						<div class="s-panel__header">
							<h3 class="title">Asistente</h3>
						</div>
						<div class="s-panel__body">
							<div class="text-center">
								<img class="s-panel__svg" src="@/assets/simulator/noEvents.svg" alt="">
								<p class="m-0 px-5">Parece que no tiene nada pendiente para el resto del día.</p>
							</div>
						</div>
						<div class="s-panel__footer">
							<div class="text-center">
								<a href="#">Ver todos</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>